import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1aa1351b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1aa1351b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa1351b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SubNav: require('/app/components/SubNav.vue').default,Sticky: require('/app/components/Sticky.vue').default,SvgPhone: require('/app/components/svg/Phone.vue').default,Anchor: require('/app/components/Anchor.vue').default,AnimBottomToTop: require('/app/components/AnimBottomToTop.vue').default})
